export default __webpack_public_path__ + "static/media/receipt_logo.7859ca3f.png";